const SMALL_WORDS = new Set([
  "a",
  "an",
  "and",
  "as",
  "at",
  "by",
  "for",
  "in",
  "of",
  "on",
  "or",
  "the",
  "to",
  "with",
]);

const UPPERCASE_TOKENS = new Set(["api", "cvv", "dob", "id", "otp", "uae", "aed"]);

function formatToken(token: string, index: number, total: number) {
  const cleaned = token.trim();
  if (!cleaned) return "";

  const lower = cleaned.toLowerCase();

  if (UPPERCASE_TOKENS.has(lower)) {
    return lower.toUpperCase();
  }

  // Preserve acronyms and mixed numeric IDs already provided in uppercase.
  if (/^[A-Z0-9]{2,}$/.test(cleaned)) {
    return cleaned;
  }

  if (SMALL_WORDS.has(lower) && index > 0 && index < total - 1) {
    return lower;
  }

  return lower.charAt(0).toUpperCase() + lower.slice(1);
}

export function toTitleCaseUi(value?: string | null) {
  if (!value) return "";

  // Preserve explicit format strings such as DD/MM/YYYY.
  if (/^[A-Za-z]{1,4}[\/-][A-Za-z]{1,4}[\/-][A-Za-z]{2,4}$/.test(value.trim())) {
    return value.trim();
  }

  const normalized = value.replace(/[_-]+/g, " ").replace(/\s+/g, " ").trim();

  if (!normalized) return "";

  const words = normalized.split(" ");
  return words.map((word, index) => formatToken(word, index, words.length)).join(" ");
}
